import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const numberFormats = {
  es: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  de: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  it: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  pt: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
}

const messages = {
  es: require('@/locales/es.json'),
  de: require('@/locales/de.json'),
  en: require('@/locales/en.json'),
  fr: require('@/locales/fr.json'),
  it: require('@/locales/it.json'),
  pt: require('@/locales/pt.json')
}
export const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  numberFormats,
  messages
})

